import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafTooltip } from '@cigna/leaf-web/lib/wc';

import '@cigna/leaf-web/lib/wc/components/tooltip/tooltip';

@Component({
  selector: 'cigna-leaf-tooltip',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-tooltip
      [ariaDescribes]="ariaDescribes"
      [position]="position"
      [knockout]="knockout"
      [isDynamic]="isDynamic"
      ><ng-content></ng-content
    ></leaf-tooltip>
  `,
})
export class CignaLeafTooltipComponent {
  @Input() ariaDescribes: LeafTooltip['ariaDescribes'];
  @Input() position: LeafTooltip['position'];
  @Input() knockout: LeafTooltip['knockout'];
  @Input() isDynamic: LeafTooltip['isDynamic'];
  // svg not working, we can add icon to trigger slot to achieve same result, see docs
  // @Input() iconRotateDegree: LeafTooltip['iconRotateDegree'];
  // @Input() iconFlipDirection: LeafTooltip['iconFlipDirection'];
  // @Input() svg: LeafTooltip['svg'];
}
